import { Content, ReverseRelation } from "@robe/core";
import { useData } from "./useData";

/**
 * useReverseRelations hook returns the reverse relations fetched in `getStaticProps`
 */
export const useReverseRelations = <TSource extends Content>(): Array<ReverseRelation>[] => {
  const { reverseRelations } = useData<TSource>();

  return reverseRelations;
};
